import React, { useEffect, useState, useMemo, useRef, useLayoutEffect } from "react";
import Buttons from "../../components/ui/button/Buttons";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import AccountInformationForm from "./component/AccountInformation/AccountInformation";
import CompanyDetailsForm from "./component/CompanyDetails/CompanyDetails";
import MembershipSubscriptionForm from "./component/MembershipSubscription/MembershipSubscription";
import PricingTableForm from "./component/PricingTable/PricingTable";
import DecisionCardCommitteeApprovalForm from "./component/DecisionCardCommitteeApproval/DecisionCardCommitteeApproval";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../utils/Encryption";
import { useLazyGetCorporateMemberDetailsbyTasklistIdQuery, useLazyGetCorporateMemberDetailsByCorporateMemberIdQuery, useLazyGetMembershipSubscriptionDetailByIdQuery, useLockCorporateApplicationByAdminMutation, useRejectCorporateMemberApplicationMutation, useSaveCorporateMemberClarificationDetailsMutation, useApproveCorporateApplicationMutation, useCreateInvoiceMutation, useDiscontinueCorporateApplicationMutation, useLazyGetCorporateMemberDetailsInAdminByTaskListIdQuery, useSaveCorporateMemberClarificationDetailsAfterApprovalMutation, useLazyGetClarificationAuditLogListByIdQuery, useCorporateApplicationReadyForApprovalMutation } from "../../app/services/CorporateMembershipTaskList/corporateMembershipTaskListApi";
import { useLazyGetSignUpDropDownsForCorporateMembersQuery } from "../../app/services/common/commonApi";
import { setFieldParameter, setFieldParameterForMembership, setFieldParameterCorporateMemberDetailsByTasklistID } from "./Utils/setFieldParameter";
import SwalAlert from "../../services/swalService/SwalService";
import { setAllDropDownField } from "./Utils/setDropDown";
import { encryptAES } from "../../services/CryptoService";
import FormCreator from "../../components/Forms/FormCreator";
import { DiscontinueApplicationdata } from "./data/DiscontinueApplication.data";
import { setFormViewOnly } from "./Utils/viewOnlyform";
import { getAuthProps } from "../../lib/authenticationLibrary";
import NoRecordFound from "../../components/ui/noRecordFound/NoRecordFound";
import { handleConditionBaseFields, includesValueNormalized } from "./Utils/MemberApplicationTaskListDetailUtils";


const MemberApplicationTaskListDetailForm = () => {
  const navigate = useNavigate();
  const { id, id2 } = useParams();
  const editID = useMemo(() => (id ? decryptAESID(id, false) : 0), [id]);
  const tasklistId = useMemo(() => (id2 ? decryptAESID(id2, false) : 0), [id2]);
  const { error, success } = SwalAlert();
  const statusForViewOnly = ["Completed", "Not Approved", "Withdrawn"];
  const DiscontinueApplicationRef = useRef();
  const authData = getAuthProps();
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [formData, setFormData] = useState(DiscontinueApplicationdata);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showDiscontinueModal, setShowDiscontinueModal] = useState(false);
  const [showClarificationModal, setShowClarificationModal] = useState(false);
  const [showClarificationAuditLogModal, setShowClarificationAuditLogModal] = useState(false);
  const [clarificationComments, setClarificationComments] = useState("");
  const [rejectionComments, setRejectionComments] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [refreshPricing, setRefreshPricing] = useState(false);
  const [refreshdrop, setRefreshDrop] = useState(false);
  const [filteredDropdowns, setFilteredDropdowns] = useState([]);
  const [isAppLocked, setIsAppLocked] = useState(true);
  const [auditLog, setAuditLog] = useState([])
  const [internalComment, setInternalComment] = useState("");

  const [getCorporateMemberDetails, corporateDetailsState] = useLazyGetCorporateMemberDetailsByCorporateMemberIdQuery();
  const [getMembershipDetails, membershipDetailsState] = useLazyGetMembershipSubscriptionDetailByIdQuery();
  const [lockCorporateApplication, lockApplicationState] = useLockCorporateApplicationByAdminMutation();
  const [fetchDropdowns, dropdownState] = useLazyGetSignUpDropDownsForCorporateMembersQuery();
  const [rejectApplication, rejectState] = useRejectCorporateMemberApplicationMutation();
  const [clarificationDetails, clarificationState] = useSaveCorporateMemberClarificationDetailsMutation();
  const [getCorporateMemberDetailsByTasklistID, CorporateMemberDetailsByTasklistID] = useLazyGetCorporateMemberDetailsbyTasklistIdQuery();
  // const [createInvoice, { isSuccess: isSuccessCreateInvoice, isLoading: isLoadingCreateInvoice, data: getCreateInvoiceResponse, },] = useCreateInvoiceMutation();
  const [approveCorporateApplication, { isSuccess: isSuccessApproveCorporateApplication, isLoading: isLoadingApproveCorporateApplication, data: getApproveCorporateApplicationResponse, },] = useApproveCorporateApplicationMutation();
  const [discontinueCorporateApplication, { isSuccess: isDiscontinueApplicationSuccess, isLoading: isDiscontinueApplicationLoading, data: discontinuationApplicationApplicationResponse }] = useDiscontinueCorporateApplicationMutation();
  const [getCorporateMemberDetailsInAdminByTaskListId, { isSuccess: isgetCorporateMemberDetailsInAdminSuccess, isLoading: isgetCorporateMemberDetailsInAdminLoading, data: getCorporateMemberDetailsInAdminResponse }] = useLazyGetCorporateMemberDetailsInAdminByTaskListIdQuery();
  const [getClarificationAuditLogList, { isSuccess: auditLogIsSuccess, isLoading: auditLogIsLoading, data: auditLogList }] = useLazyGetClarificationAuditLogListByIdQuery();
  const [sendForApproval, { data: approvalResponse, isLoading: approvalSending },] = useCorporateApplicationReadyForApprovalMutation();

  const refreshPricingTable = () => {
    setRefreshPricing(prev => !prev);
  };

  const refreshDropdowns = () => {
    setRefreshDrop(prev => !prev);
  };

  useEffect(() => {
    if (id && tasklistId) {
      getCorporateMemberDetailsByTasklistID({
        id: encryptAES(editID),
        id2: encryptAES(tasklistId),
      });
    }
  }, [editID, tasklistId]);

  useEffect(() => {
    if (id && tasklistId) {
      getClarificationAuditLogList({ id: encryptAES(editID), id2: encryptAES(tasklistId), });
    }
  }, [editID, tasklistId]);

  useEffect(() => {
    const { data, isLoading } = CorporateMemberDetailsByTasklistID;
    if (!isLoading && data) {
      setIsAppLocked(data?.isLock == true ? false : true);
      setFieldParameterCorporateMemberDetailsByTasklistID(data);
    }
  }, [CorporateMemberDetailsByTasklistID]);

  useEffect(() => {
    if (auditLogIsSuccess && !auditLogIsLoading && auditLogList) {
      setAuditLog(auditLogList)
    }
  }, [auditLogIsSuccess, auditLogIsLoading, auditLogList])

  useEffect(() => {
    fetchDropdowns();
    if (editID) {
      getCorporateMemberDetails(editID);
      getMembershipDetails(tasklistId);
      getCorporateMemberDetailsInAdminByTaskListId(tasklistId);
    }
  }, [editID, refreshdrop]);

  useEffect(() => {
    const { data, isLoading } = corporateDetailsState;
    if (!isLoading && data) {
      setFieldParameter(data);
    }
  }, [corporateDetailsState]);

  useEffect(() => {

    if (dropdownState?.data && corporateDetailsState?.data) {
      // const updatedDropdowns = corporateDetailsState.data.isPSPCListedOrg ? dropdownState.data : dropdownState.data.filter(item => item.name !== "Bundle");
      setFilteredDropdowns([...dropdownState?.data]);
      setAllDropDownField([...dropdownState?.data]);
    }

  }, [dropdownState?.data, corporateDetailsState?.data, refreshdrop]);

  useEffect(() => {
    const { data, isLoading } = membershipDetailsState;
    if (!isLoading && data) {
      setFieldParameterForMembership(data);
    }
  }, [membershipDetailsState]);

  useEffect(() => {
    const { isSuccess, isLoading, data } = lockApplicationState;
    if (!isLoading && isSuccess && data?.keyId > 0) {
      getCorporateMemberDetailsByTasklistID({
        id: encryptAES(editID),
        id2: encryptAES(tasklistId),
      });
      success("Application locked successfully.");
      getCorporateMemberDetails(editID);
      getCorporateMemberDetailsInAdminByTaskListId(tasklistId);
    }
  }, [lockApplicationState]);

  useEffect(() => {
    const { isSuccess, isLoading } = rejectState;
    if (!isLoading && isSuccess) {
      success("Application rejected successfully.");
      setShowRejectModal(false);
      navigate("/membershipApplicationList");
    }
  }, [rejectState]);

  useEffect(() => {
    const { isSuccess, isLoading } = clarificationState;
    if (!isLoading && isSuccess) {
      success("Clarification sent successfully.");
      setShowClarificationModal(false);
      setClarificationComments("");
      navigate("/membershipApplicationList");
    }
  }, [clarificationState]);

  useEffect(() => {
    if (!isLoadingApproveCorporateApplication && isSuccessApproveCorporateApplication && getApproveCorporateApplicationResponse) {
      success("Information has been sent to Xero.");
      closeAcceptModal();
      setPoNumber("");
      navigate("/membershipApplicationList");
    }
  }, [isLoadingApproveCorporateApplication, isSuccessApproveCorporateApplication, getApproveCorporateApplicationResponse,]);

  useEffect(() => {
    if (!isDiscontinueApplicationLoading && isDiscontinueApplicationSuccess && discontinuationApplicationApplicationResponse) {
      if (discontinuationApplicationApplicationResponse?.hasError === false) {
        success("Application has been discontinued");
        setShowDiscontinueModal(false)
      }
      else {
        error(discontinuationApplicationApplicationResponse?.errorMessage);
      }
      navigate("/membershipApplicationList");
    }
  }, [isDiscontinueApplicationLoading, isDiscontinueApplicationSuccess, discontinuationApplicationApplicationResponse])

  useEffect(() => {
    if (!isgetCorporateMemberDetailsInAdminLoading && getCorporateMemberDetailsInAdminResponse) {
      if (statusForViewOnly?.includes(getCorporateMemberDetailsInAdminResponse?.corporateStatusName)) {
        setFormViewOnly(true);
        setIsViewOnly(true);
      }
    }
  }, [isgetCorporateMemberDetailsInAdminLoading, getCorporateMemberDetailsInAdminResponse, isgetCorporateMemberDetailsInAdminSuccess]);

  useEffect(() => {
    if (!approvalSending && approvalResponse) {
      if (!approvalResponse.hasError) {
        success("Application sent for committee approval!");
      } else {
        error("Application already sent for approval");
      }
    }
  }, [approvalSending, approvalResponse]);

  const handleSave = () => {
    sendForApproval({
      SGBCCorporateMemberId: editID,
      InternalComment: internalComment || null,
    });
  };

  const handleLock = () => {
    lockCorporateApplication({ SGBCCorporateMemberId: editID, TaskListId: tasklistId });
  };

  const handleRejectApplication = () => {
    if (!rejectionComments.trim()) {
      error("Please enter a rejection reason");
      return;
    }

    rejectApplication({
      SGBCCorporateMemberId: editID,
      RejectDetails: rejectionComments
    });
  };

  // send clarification
  const handleSendClarification = () => {
    if (!clarificationComments.trim()) {
      // alert("Please enter comments before sending.");
      return;
    }
    let req = {
      SGBCCorporateMemberId: editID,
      ClarificationDetails: clarificationComments,
      TaskListId: tasklistId,
      ByWho: authData?.userName,
    }
    clarificationDetails(req);
  };

  const dropdownData = filteredDropdowns;
  const membershipData = membershipDetailsState?.data;
  const corporateData = corporateDetailsState?.data;

  const handleBack = () => {
    navigate(`/membershipApplicationList`);
  }

  const closeAcceptModal = () => {
    setShowAcceptModal(false);
    setPoNumber("");
  }

  const closeAuditModal = () => {
    setShowClarificationAuditLogModal(false);
    setPoNumber("");
  }

  const handleAcceptApplication = () => {
    setShowAcceptModal(true);
  }

  // useEffect(() => {
  //   if (isSuccessCreateInvoice && getCreateInvoiceResponse) {
  //     if (getCreateInvoiceResponse?.hasErrors === false) {
  //       approveCorporateApplication({
  //         SGBCCorporateMemberId: editID,
  //         PONumber: poNumber || null,
  //         IsRenewal: corporateData?.isRenewal
  //       });
  //     }
  //     else {
  //       error("Failed to create invoice in Xero. Please try again.")
  //     }
  //   }
  // }, [getCreateInvoiceResponse])

  const onApproveClick = () => {
    approveCorporateApplication({
          SGBCCorporateMemberId: editID,
          PONumber: poNumber || null,
          IsRenewal: corporateData?.isRenewal
        });
  };

  const handleDiscontinue = () => {
    const DiscontinueApplicationdata = DiscontinueApplicationRef?.current?.getFormData();
    if (!DiscontinueApplicationdata) {
      error("Please fill in all mandatory fields to continue.", "")
      return;
    }
    const req = {
      SGBCCorporateMemberId: editID,
      SGBCCorporateMemberTaskListId: tasklistId,
      DiscontinueReasonId: DiscontinueApplicationdata?.discontinueReasonId?.value || DiscontinueApplicationdata?.discontinueReasonId,
      OtherDiscontinuedReason: DiscontinueApplicationdata?.otherDiscontinuedReason || null,
      InternalComment: DiscontinueApplicationdata?.internalComments || null,
    }
    discontinueCorporateApplication(req)
  }

  const handleFormFieldChange = (dataField, value) => {
    const selectedValue = value?.value ?? value;
    const nextFormDataBase = { ...formData, initialState: { ...formData.initialState, [dataField]: selectedValue } };

    if (dataField === "discontinueReasonId") {
      let updated = handleConditionBaseFields(selectedValue, nextFormDataBase, "otherDiscontinuedReason", 10);
      if (!includesValueNormalized(selectedValue, 10)) {
        updated = { ...updated, initialState: { ...updated.initialState, otherDiscontinuedReason: null } };
      }
      setFormData(updated);
      return;
    }
    setFormData(nextFormDataBase);
  };

  return (
    <div className="member-application-data-list-form">
      <div className="application-status-section">
        <div className="status-label">
          <label>Application Status</label>
        </div>
        <div className="status-field">
          <select className="status-dropdown" value={getCorporateMemberDetailsInAdminResponse?.corporateStatusName || ""} disabled>
            <option>{getCorporateMemberDetailsInAdminResponse?.corporateStatusName}</option>
          </select>
          {CorporateMemberDetailsByTasklistID?.data?.isLock == true || getCorporateMemberDetailsInAdminResponse?.corporateStatusName==='Decision Unknown' || getCorporateMemberDetailsInAdminResponse?.corporateStatusName==='Discontinued' || getCorporateMemberDetailsInAdminResponse?.corporateStatusName==='Draft' ? (
            <button className="unlock-button" disabled={!isAppLocked}>
              Lock Application
            </button>
          ) : (
            <button className="lock-button" onClick={handleLock} disabled={!isAppLocked}>
              Lock Application
            </button>
          )}
        </div>
      </div>
      {dropdownData && corporateData && (<AccountInformationForm isViewOnly={isViewOnly} isAppLocked={isAppLocked} />)}
      {dropdownData && corporateData && (<CompanyDetailsForm dropDownList={dropdownData} isViewOnly={isViewOnly} isRenewalCheck={corporateData?.isRenewal} onCompanyUpdated={refreshDropdowns} isAppLocked={isAppLocked} />)}
      {dropdownData && membershipData && corporateData && (<MembershipSubscriptionForm key={refreshdrop} subscriptionType={membershipData?.membershipPaymentTypeId} membershipData={membershipData} dropdownData={dropdownData} onSubscriptionUpdated={refreshPricingTable} isViewOnly={isViewOnly} refreshdrop={refreshdrop} isAppLocked={isAppLocked} />)}
      {dropdownData && corporateData && (<PricingTableForm subscriptionType={membershipData?.membershipPaymentTypeId} refresh={refreshPricing} tasklistId={tasklistId} isViewOnly={isViewOnly} isAppLocked={isAppLocked} isQuotation={corporateData?.isQuotation} />)}
      {!corporateData?.isRenewal && <DecisionCardCommitteeApprovalForm internalComment={internalComment} setInternalComment={setInternalComment} tasklistId={tasklistId ? encryptAES(tasklistId) : null} isViewOnly={isViewOnly} isAppLocked={isAppLocked} />}
      <div className="btn-bottom mt-5">
        <Buttons
          buttonText="Back"
          buttonTypeClassName="black-btn"
          onClick={handleBack}
        />
        <div className="d-flex gap-5">

          {corporateData?.isRenewal ?
            <Buttons
              buttonText="Withdraw Application"
              buttonTypeClassName="danger-btn"
              onClick={() => setShowDiscontinueModal(true)}
              isDisable={isViewOnly || (membershipData?.isExpiredInSameYear && (membershipData?.membershipPaymentTypeId == 2 || membershipData?.membershipPaymentTypeId == 3)) || membershipData?.isParentExpired || isAppLocked}
            />
            :
            <Buttons
              buttonText="Withdraw Application"
              buttonTypeClassName="danger-btn"
              onClick={() => setShowRejectModal(true)}
              isDisable={isViewOnly || (membershipData?.isExpiredInSameYear && (membershipData?.membershipPaymentTypeId == 2 || membershipData?.membershipPaymentTypeId == 3)) || membershipData?.isParentExpired || isAppLocked}
            />
          }
          <Buttons
            buttonText="Clarification Audit Log"
            buttonTypeClassName="success-btn"
            onClick={() => setShowClarificationAuditLogModal(true)}
          // isDisable={isViewOnly || (membershipData?.isExpiredInSameYear && membershipData?.membershipPaymentTypeId == 2 || membershipData?.membershipPaymentTypeId == 3) || membershipData?.isParentExpired || isAppLocked}
          />
          <Buttons
            buttonText="Send Clarification"
            buttonTypeClassName="success-btn"
            onClick={() => setShowClarificationModal(true)}
            isDisable={isViewOnly || (membershipData?.isExpiredInSameYear && (membershipData?.membershipPaymentTypeId == 2 || membershipData?.membershipPaymentTypeId == 3)) || membershipData?.isParentExpired || isAppLocked}
          />
          {!corporateData?.isRenewal && <Buttons
            buttonText="Ready for Approval"
            buttonTypeClassName="success-btn"
            onClick={handleSave}
            isLoading={approvalSending}
            isDisable={isViewOnly || isAppLocked || approvalSending}
          />}
          {corporateData?.isRenewal &&
            <Buttons
              buttonText="Send for Payment"
              buttonTypeClassName="success-btn"
              isLoading={isLoadingApproveCorporateApplication}
             // isDisable={isLoadingApproveCorporateApplication || corporateData?.statusId == 9 || isViewOnly || (membershipData?.isExpiredInSameYear && (membershipData?.membershipPaymentTypeId == 2 || membershipData?.membershipPaymentTypeId == 3)) || membershipData?.isParentExpired || isAppLocked}
             isDisable={true}
              onClick={() => handleAcceptApplication(true)}
            />
          }
        </div>

      </div>
      <CenterModel
        show={showAcceptModal}
        handleClose={closeAcceptModal}
        modelTitle="Invoice information will be pushed to Xero "
      >
        <p className="">Please enter a PO number, if applicable</p>
        <input
          type="text"
          className="form-control mt-2"
          placeholder=""
          value={poNumber}
          onChange={(e) => setPoNumber(e.target.value)}
        />

        <div className="d-flex justify-content-between gap-2 mt-4">
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="black-btn"
            onClick={closeAcceptModal}
          />
          <Buttons
            buttonText="Proceed"
            buttonTypeClassName="success-btn"
            value={poNumber}
            onClick={onApproveClick}
            isLoading={isLoadingApproveCorporateApplication }
            isDisable={isLoadingApproveCorporateApplication }
          />
        </div>
      </CenterModel>
      <CenterModel
        show={showRejectModal}
        handleClose={() => (setShowRejectModal(false), setRejectionComments(""))}
        modelTitle="Confirmation"
      >
        <p>Enter Withdrawal Reason which would be displayed in the withdrawal email sent to the Applicant.</p>

        <textarea
          className="form-control mt-2"
          rows="3"
          placeholder=""
          onChange={(e) => setRejectionComments(e.target.value)}
        />

        <div className="d-flex justify-content-between gap-2 mt-4">
          <Buttons buttonText="Cancel" buttonTypeClassName="black-btn" onClick={() => (setShowRejectModal(false), setRejectionComments(""))} />
          <Buttons
            buttonText="Confirm"
            buttonTypeClassName="success-btn"
            onClick={handleRejectApplication}
            isLoading={rejectState.isLoading}
          />
        </div>
      </CenterModel>
      <CenterModel
        show={showDiscontinueModal}
        handleClose={() => setShowDiscontinueModal(false)}
        modelTitle="Confirmation">
        <div>
          <FormCreator
            ref={DiscontinueApplicationRef}
            onFormFieldValueChange={handleFormFieldChange}
            {...formData}
          />
          {/* <p>This will update member's application status to Discontinue</p> */}
        </div>
        <div className="d-flex justify-content-between mt-4">
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="black-btn"
            onClick={() => setShowDiscontinueModal(false)}
          />

          <Buttons
            buttonText="Confirm"
            buttonTypeClassName="success-btn"
            onClick={() => handleDiscontinue()}
            isLoading={isDiscontinueApplicationLoading}
            isDisable={isDiscontinueApplicationLoading}
          />
        </div>
      </CenterModel>

      <CenterModel
        show={showClarificationModal}
        handleClose={() => (setShowClarificationModal(false), setClarificationComments(""))}
        modelTitle="Send Clarifications"
      >
        <textarea
          className="form-control mt-2"
          rows="4"
          placeholder=""
          value={clarificationComments}
          onChange={(e) => setClarificationComments(e.target.value)}
        />
        <div className="d-flex justify-content-between gap-2 mt-4">
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="black-btn"
            onClick={() => (setShowClarificationModal(false), setClarificationComments(""))}
          />
          <Buttons
            buttonText="Send"
            buttonTypeClassName="success-btn"
            onClick={handleSendClarification}
            isLoading={clarificationState?.isLoading}
            isDisable={clarificationState?.isLoading}
          />
        </div>
      </CenterModel>

      {/* Clarification Audit Log Model  Start*/}
      <CenterModel
        show={showClarificationAuditLogModal}
        handleClose={closeAuditModal}
        modelTitle="Clarification Audit Log"
      >
        <div className="main-commnum-table-section clarification-audit-table">
          <table>
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>Sent By</th>
                <th>Clarification</th>
                <th>Triggered At (Application Status)</th>
              </tr>
            </thead>
            <tbody>
              {auditLog?.length > 0 ? auditLog.map((item, key) => {
                return (
                  <tr>
                    <>
                      <td>{item?.timeStamp}</td>
                      <td>{item?.byWho}</td>
                      <td>{item?.clarificationNote}</td>
                      <td>{item?.triggeredAt}</td>
                    </>
                  </tr>
                )
              }) :
                <td colSpan={100}><NoRecordFound /></td>
              }


            </tbody>
          </table>
        </div>

      </CenterModel>
      {/* Clarification Audit Log Model  End*/}

    </div>
  );
};

export default MemberApplicationTaskListDetailForm;
